
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '../../styles/enums';
import { InputEventType, StyleFillType } from './enums';
import Icon from '../icon';
import Gutter from '../gutter';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import InputStyleProps from './mixins/InputStyleProps';
import InputNumberProps from './mixins/InputNumberProps';
import InputValidationProps from './mixins/InputValidationProps';
import InputTextProps from './mixins/InputTextProps';
import InputCommonProps from './mixins/InputCommonProps';
import InputAutocompleteProps from './mixins/InputAutocompleteProps';
import InputEvents from './mixins/InputEvents';

export default {
  name: 'Input',
  components: {
    Gutter,
    Icon,
  },
  mixins: [
    InputStyleProps,
    InputNumberProps,
    InputValidationProps,
    InputTextProps,
    InputCommonProps,
    InputAutocompleteProps,
    InputEvents,
  ],
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
    };
  },
  computed: {
    wrapperClassNames() {
      return new StyleClassNamesBuilder('input')
        .addColorSchemeConditionClassNames(this.conditionColorScheme)
        .addConditionClassNames(Object.values(StyleFillType), this.conditionFillType)
        .addClassName(this.className)
        .build();
    },
    inputClassNames() {
      return new StyleClassNamesBuilder('input__section')
        .addConditionClassName('error', this.isShowErrorMessage)
        .addConditionClassName('disabled', this.disabled)
        .addClassName(this.inputClassName)
        .build();
    },
    inputLabelClassNames() {
      return new StyleClassNamesBuilder('input__label')
        .addColorSchemeConditionClassNames(this.labelColorScheme)
        .addConditionClassName('error', this.isShowErrorMessage)
        .addConditionClassName('disabled', this.disabled)
        .addConditionClassName('focused', !!this.value || !!this.placeholder)
        .addConditionClassName('outlined', this.fillType === StyleFillType.Outlined)
        .build();
    },
    conditionFillType() {
      if (this.disabled) {
        return StyleFillType.Dashed;
      }

      return this.fillType;
    },
    conditionColorScheme() {
      if (this.isShowErrorMessage) {
        return StyleColorSchemeType.Danger;
      }

      if (this.disabled) {
        return StyleColorSchemeType.GrayLight;
      }

      return this.colorScheme;
    },
    conditionIconColor() {
      if (this.isShowErrorMessage) {
        return StyleColorSchemeType.Danger;
      }

      if (this.disabled) {
        return StyleColorSchemeType.GrayLight;
      }

      return this.iconColor;
    },
  },
  methods: {
    handleChange(event) {
      this.emitChange(event.target.value);
    },
    handleFocus(event) {
      this.emitFocus(event.target.value);
    },
    handleBlur(event) {
      this.emitBlur(event.target.value);
    },
    handleKeydown(event) {
      this.emitKeyDown(event);
    },
    handleKeyup(event) {
      this.emitKeyUp(event);
    },
    handleKeypress(event) {
      this.emitKeyPress(event);
    },
    handleAppendIconClick() {
      this.$emit(InputEventType.AppendIconClick);
    },
  },
};
